module.exports = "pegasus_template/assets/themelp1/small/6.png";